/**
 * ContainerPadding.jsx
 *
 * Layout wrapper for internal pages that need centered, padded content.
 * Wraps the child route in PageShell to provide:
 * - Gradient background matching Home page
 * - Branded page header (back button, title, bell, avatar)
 * - Responsive padding and max-width container
 * - Bottom padding for nav-rail clearance
 *
 * Used by routes: oral-photo, appointments, dental-records, dentist/availability
 */
import {Outlet} from 'react-router';
import PageShell from './PageShell';

export default function ContainerPadding() {
  return (
    <PageShell title="" showHeader={false}>
      <Outlet />
    </PageShell>
  );
}
